// extracted by mini-css-extract-plugin
export default {"view-header":"style_view-header__rtvcU","header-left":"style_header-left__ChBDA","header-right":"style_header-right__Bbb6-","export-pdf":"style_export-pdf__UMEaC"};